import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";

import {
  saveInstalaxmiPopupRequest,
  saveInstalaxmiPopupSuccess,
  saveInstalaxmiPopupFailure,
  getInstalaxmiPopupsRequest,
  getInstalaxmiPopupsSuccess,
  getInstalaxmiPopupsFailure,
  updateInstalaxmiPopupStatusRequest,
  updateInstalaxmiPopupStatusSuccess,
  updateInstalaxmiPopupStatusFailure,
  getJewellerInstalaxmiPopupRequest,
  getJewellerInstalaxmiPopupSuccess,
  getJewellerInstalaxmiPopupFailure,
  JEWELLER_POPUP_LOGIN_FLAG,
} from "./luckyDrawPopupSlice";

const buildPopupFormData = (body = {}) => {
  const formData = new FormData();

  if (body.id) formData.append("id", body.id);
  formData.append("type", body.type);
  formData.append("status", body.status ? "true" : "false");

  if (body.type === "Custom") {
    formData.append("jewellerIds", JSON.stringify(body.jewellerIds || []));
  }

  (body.files || []).forEach((file) => {
    formData.append("files", file);
  });

  return formData;
};

function* handleSaveInstalaxmiPopup(action) {
  try {
    const { body, listParams } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/saveInstalaxmiPopup`,
      buildPopupFormData(body),
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    if (response.data.success) {
      yield put(saveInstalaxmiPopupSuccess(response.data));
      toast.success(response.data.message || "Popup saved successfully");
      yield put(getInstalaxmiPopupsRequest(listParams));
    } else {
      yield put(saveInstalaxmiPopupFailure(response.data.message));
      toast.error(response.data.message || "Failed to save popup");
    }
  } catch (error) {
    yield put(saveInstalaxmiPopupFailure(error.message));
    toast.error(error.response?.data?.message || "Failed to save popup");
  }
}

function* fetchInstalaxmiPopups(action) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/getInstalaxmiPopups`,
      { params: action.payload || {} },
    );

    yield put(getInstalaxmiPopupsSuccess(response.data));
  } catch (error) {
    yield put(getInstalaxmiPopupsFailure(error.message));
    toast.error(error.response?.data?.message || "Failed to fetch popups");
  }
}

function* handleUpdateInstalaxmiPopupStatus(action) {
  try {
    const { id, status, listParams } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/updateInstalaxmiPopupStatus/${id}`,
      { status },
    );

    if (response.data.success) {
      yield put(updateInstalaxmiPopupStatusSuccess(response.data));
      toast.success(
        response.data.message || "Popup status updated successfully",
      );
      yield put(getInstalaxmiPopupsRequest(listParams));
    } else {
      yield put(updateInstalaxmiPopupStatusFailure(response.data.message));
      toast.error(response.data.message || "Failed to update popup status");
    }
  } catch (error) {
    yield put(updateInstalaxmiPopupStatusFailure(error.message));
    toast.error(
      error.response?.data?.message || "Failed to update popup status",
    );
  }
}

function* fetchJewellerInstalaxmiPopup() {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/jeweller-lucky-draw/getJewellerInstalaxmiPopup`;
  console.log("[JewellerPopup] saga START GET", {
    url,
    path: window.location.pathname,
    popupFlag: localStorage.getItem(JEWELLER_POPUP_LOGIN_FLAG),
  });

  try {
    const response = yield call(axios.get, url);

    console.log("[JewellerPopup] saga SUCCESS", {
      httpStatus: response.status,
      success: response.data?.success,
      message: response.data?.message,
      hasData: !!response.data?.data,
      filesCount: response.data?.data?.files?.length || 0,
      data: response.data?.data,
    });

    localStorage.removeItem(JEWELLER_POPUP_LOGIN_FLAG);
    console.log("[JewellerPopup] flag cleared after GET completed");

    if (response.data?.success) {
      yield put(getJewellerInstalaxmiPopupSuccess(response.data.data || null));
    } else {
      console.log("[JewellerPopup] saga FAILURE reason: response.success is false", {
        httpStatus: response.status,
        body: response.data,
      });
      yield put(getJewellerInstalaxmiPopupFailure());
    }
  } catch (error) {
    const canceled =
      error.code === "ERR_CANCELED" ||
      error.name === "CanceledError" ||
      axios.isCancel?.(error);
    const reason = canceled
      ? "REQUEST CANCELED (page reload/navigation aborted GET after OPTIONS)"
      : error.response
        ? `HTTP ${error.response.status}`
        : error.code || error.message;

    console.log("[JewellerPopup] saga FAILURE", {
      reason,
      canceled,
      code: error.code,
      name: error.name,
      message: error.message,
      httpStatus: error.response?.status,
      responseData: error.response?.data,
      path: window.location.pathname,
    });
    yield put(getJewellerInstalaxmiPopupFailure());
  }
}

export function* luckyDrawPopupSaga() {
  yield takeLatest(saveInstalaxmiPopupRequest.type, handleSaveInstalaxmiPopup);
  yield takeLatest(getInstalaxmiPopupsRequest.type, fetchInstalaxmiPopups);
  yield takeLatest(
    updateInstalaxmiPopupStatusRequest.type,
    handleUpdateInstalaxmiPopupStatus,
  );
  yield takeLatest(
    getJewellerInstalaxmiPopupRequest.type,
    fetchJewellerInstalaxmiPopup,
  );
}
